import { ConfirmTradeAction } from '../../tradeBlotter/actions'
import { addOrUpdateAggressAttempt } from './helpers'
import { AggressAttemptAction } from './actions'
import { AggressAttempt } from './types'

export interface State {
  aggressAttempts?: AggressAttempt[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  aggressAttempts: undefined,
  pending: true,
  error: false
}

export default (
  state = initialState,
  action: AggressAttemptAction | ConfirmTradeAction
): State => {
  switch (action.type) {
    case 'aggressAttempts.fetch':
      return {
        ...state,
        pending: true,
        aggressAttempts: undefined,
        error: false
      }
    case 'aggressAttempts.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'aggressAttempts.addAggressAttempt':
      let items: AggressAttempt[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.aggressAttempts) {
        return {
          ...state,
          aggressAttempts: items
        }
      }

      return {
        ...state,
        aggressAttempts: addOrUpdateAggressAttempt(state.aggressAttempts, items)
      }

    case 'tradeBlotter.confirmTrade': {
      const attempts = state.aggressAttempts?.map((aa) => {
        if (aa.makerTicketId === action.payload) {
          return { ...aa, makerVconState: 3 } satisfies AggressAttempt
        }
        if (aa.takerTicketId === action.payload) {
          return { ...aa, takerVconState: 3 } satisfies AggressAttempt
        }
        return aa
      })
      return {
        ...state,
        aggressAttempts: attempts
      }
    }

    default:
      return state
  }
}
